import 'intersection-observer';

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'tanok';
import { StickyContainer } from 'react-sticky';
import { getRoom } from '@evo/chat-core';
import { t } from 'c-3po';

import * as a from '../../../../../libs/actions';
import * as c from '../../../../../libs/constants';
import * as aggr from '../../../../../libs/aggregation';
import {
    splitHistoryByDays,
    withContextOnly,
    getSplitLineDate,
    getElementScrollBotPosition,
} from '../../../../../libs/helpers/index';
import {
    isEmpty,
    getSocketStore,
    isOppositeUserTyping
} from '../../../../../libs/utils';
import { toJS } from '../../../../helpers/ImmutableToJS';

import { Spinner } from '../../../../ui/spinner';
import { Icon } from '../../../../ui/icon';
import { Notice } from '../../../../ui/notice';

import { Message } from './message';
import { Typing } from './typing';
import { FileInput } from './fileInput';

import { SafetyRecommendationMsg } from './message/recommendation';
import { BanNotification } from './banNotification';
import { DisableChatNotification } from './disableChatNotification'

// styles
import css from './dialog.sss';

// images
import SendIconSvg from './images/send.icon.svg';
import EmptyMessagesSvg from './images/emptyMessages.svg';

import { Config } from '../../../../../core/config';

class DialogView extends React.Component {
    static propTypes = {
        currentChatRoom: PropTypes.object,
        errors: PropTypes.object,
        isLoadingData: PropTypes.object,
        chatMsgText: PropTypes.string,
        dialogInputRows: PropTypes.number,
        newMsgMarkShown: PropTypes.bool,
        goBotOnMsg: PropTypes.bool,
        inputBlocked: PropTypes.bool,
        isDialogInputEmpty: PropTypes.bool,
        showTyping: PropTypes.bool,
        markMsgRead: PropTypes.func,
        sendMsg: PropTypes.func,
        retrySendMsg: PropTypes.func,
        sendTyping: PropTypes.func,
        sendCtx: PropTypes.func,
        closeDialog: PropTypes.func,
        openRoom: PropTypes.func,
        chatMsgChange: PropTypes.func,
    };

    state = {
        formHeight: 48
    };

    componentWillMount() {
        const options = {
            root: this.dialogContainer,
            rootMargin: '0px',
            threshold: 0.75,
        };

        this.intersectionObserver = new IntersectionObserver(this.handleNewMarkDetect, options);
    }

    componentDidMount() {
        this.besidaMsgContainer && this.scrollDialogToBottomIfAble();
    }

    componentDidUpdate() { this.besidaMsgContainer && this.scrollDialogToBottomIfAble(); }

    componentWillUnmount() {
        this.intersectionObserver && this.intersectionObserver.disconnect();
        this.prevHistoryCnt = 0;
        this.props.send(a.EVENT_DIALOG_CLEAR_CONTAINER);
    }


    scrollDialogToBottomIfAble() {
        if ((!this.props.currentChatRoom || (
            this.props.isLoadingData.chatChannel ||
            this.props.isLoadingData.history
            ) || this.invokedOnce) && !this.props.goBotOnMsg) return void 0;

        const curHistory = this.props.currentChatRoom.history;
        const dialogContainer = document.getElementById('dialogMainContainerMobile');

        if ((!curHistory || (this.prevHistoryCnt === curHistory.length)) && (
                this.props.dialogInputRows < 4) && !this.props.goBotOnTyping) return void 2 / 0;

        if (!this.invokedOnce && dialogContainer) {
            this.invokedOnce = true;
            this.props.send(a.EVENT_DIALOG_SEND_CONTAINER, { container: dialogContainer });
        }

        this.handleScrollBottom();

        this.prevHistoryCnt = curHistory.length;

        this.props.send(a.EVENT_DIALOG_DISABLE_MSG_SCROLL);
        return void 0;
    }

    bindDialogContainer = () => {
        const roomHistory = (this.props.currentChatRoom && this.props.currentChatRoom.history) || [];

        (!this.besidaMsgContainer || (
            this.prevHistoryCnt !== roomHistory.length
        )) && (this.besidaMsgContainer = document.getElementById('dialogMainContainerMobile'));
    }

    handleScrollBottom = () => {
        const dialogContainer = document.getElementById('dialogMainContainerMobile');
        const scrollDiff = getElementScrollBotPosition(dialogContainer);
        if (scrollDiff > 0) dialogContainer.scrollTop = scrollDiff;
        return void 0;
    }

    handleNewMarkDetect = (entries, observer) => {
        entries.forEach((entry) => {
            observer.unobserve(entry.target);
        });
        this.props.send(a.EVENT_DIALOG_SAW_MSG_MARK);
    }

    handleInputKeyPress = (event) => {
        const { charCode, shiftKey } = event;

        const enterPressed = charCode === c.KEY_CODE_ENTER;

        switch (true) {
            case (enterPressed && shiftKey):
                return void 0;
            case enterPressed:
                event.preventDefault();
                this.props.sendMsg();
                return void 0;
            default:
        }

        this.props.sendTyping();
        return void 0;
    }

    handleKeyUp = ({ keyCode }) => {
        const upPressed = keyCode === c.KEY_CODE_UP;
        upPressed && this.props.send(a.EVENT_DIALOG_SET_MSG_FROM_DRAFT);

        const element = this.ghost;
        this.setState({
            formHeight: element.clientHeight,
        });
    }

    whichPopUp = (isBannedRoom) => {
        if (isBannedRoom) return <BanNotification  backToChatList={this.props.backToChatList} />
        if (this.props.disabledChat) return <DisableChatNotification />
        return (null);
    }

    prevHistoryCnt = 0;
    invokedOnce = false;

    render() {
        const { CORE_BESIDA_IMAGE_UPLOAD, CORE_BANNED_SKK_NOTIFICATION } = Config.data.appState;
        const { currentChatRoom, isLoadingData,
            markMsgRead, isDialogInputEmpty, disabledChat,
            inputBlocked, retrySendMsg, showTyping, retrySendFile, retrySendFileCtx,
            companyBannedSKK, isCompanyC2C } = this.props;

        const room = currentChatRoom;

        if (!room) return null;
        if (isLoadingData.chatChannel) return <Spinner />;

        const isBannedRoom = (
            currentChatRoom.companyBanned
            || currentChatRoom.clientBanned
            || (companyBannedSKK && CORE_BANNED_SKK_NOTIFICATION)
        );

        return (
            <div
                ref={(node) => { this.dialogContainer = node; }}
                className={css.root}
            >
                <StickyContainer
                    className={css.body}
                    data-qaid='chat_block'
                    ref={this.bindDialogContainer}
                    id='dialogMainContainerMobile'
                >
                    {!isEmpty(room.history) ? (
                        <React.Fragment>
                            {splitHistoryByDays(room.history).map((chatMap) => (
                                <div key={`${chatMap[0]}dateMessages`} className={css.group}>
                                    {!(withContextOnly(chatMap[1])) && (
                                        <div
                                            className={css.dateWrapper}
                                            title={chatMap[0]}
                                            key={`${chatMap[0]}dateSplitter`}
                                        >
                                            <span className={css.date}>
                                                {getSplitLineDate(chatMap[0])}
                                            </span>
                                        </div>
                                    )}
                                    <ul className={css.messagesList}>
                                        {chatMap[1].map((msg) => (
                                            <Message
                                                msgId={msg.id}
                                                key={`${msg.id}rowMsg`}
                                                intersectionObserver={this.intersectionObserver}
                                                markMsgRead={markMsgRead}
                                                retrySendMsg={retrySendMsg}
                                                retrySendFile={retrySendFile}
                                                retrySendFileCtx={retrySendFileCtx}
                                                triggerScroll={this.handleScrollBottom}
                                            />
                                        ))}
                                    </ul>
                                </div>
                            ))}
                            {showTyping && <Typing />}
                        </React.Fragment>
                    ) : (
                        <Notice
                            image={EmptyMessagesSvg}
                            title={t`Нет сообщений`}
                        >
                            {t`Быстро и удобно задавайте вопросы продавцам`}
                        </Notice>
                    )}
                    {isLoadingData.history && (
                        <Spinner />
                    )}
                </StickyContainer>

                <div className={css.footer}>
                    {isCompanyC2C && <SafetyRecommendationMsg />}
                    {isBannedRoom || disabledChat ? (
                        <div>
                            { this.дwhichPopUp(isBannedRoom) }
                        </div>
                    ) : (
                        <div
                            className={css.form}
                            data-qaid='send_form_block'
                        >
                            <span
                                className={isDialogInputEmpty || inputBlocked || disabledChat ? css.sendButtonDisabled : css.sendButton}
                                onClick={this.props.sendMsg}
                                data-qaid='send_btn'
                                title={t`отправить`}
                            >
                                <Icon
                                    className={css.sendIcon}
                                    glyph={SendIconSvg}
                                />
                            </span>
                            {CORE_BESIDA_IMAGE_UPLOAD &&
                                <span className={css.uploader}>
                                    <FileInput send={this.props.send} />
                                </span>
                            }
                            <textarea
                                onChange={this.props.chatMsgChange}
                                onKeyPress={this.handleInputKeyPress}
                                onKeyUp={this.handleKeyUp}
                                value={this.props.chatMsgText}
                                className={css.textField}
                                data-qaid='msg_textarea'
                                placeholder={t`Ваше сообщение...`}
                                maxLength={1000}
                                style={{ height: `${this.state.formHeight}px` }}
                                ref={(node) => {this.inputNode = node}}
                            />
                            {/* need for calc dynamic textarea height */}
                            <div
                                className={css.textFieldSpacer}
                                ref={(spacer) => {this.ghost = spacer}}
                            >
                                {this.props.chatMsgText}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const socketStore = getSocketStore(state);
    const currentChatRoom = getRoom(socketStore, state.get('openedRoomIdent'));
    const isDialogInputEmpty = aggr.isDialogInputEmpty(state.get('chatMsgText'));
    const companyBannedSKK = currentChatRoom.getIn(['extra', 'is_banned_skk']);
    const isPortalChatVisible = !!currentChatRoom.getIn(['extra', 'is_portal_chat_visible']);
        const isCompanyC2C = currentChatRoom.getIn(['extra', 'company_type']) === c.COMPANY_C2C_TYPE;

    return {
        chatHeightCoefficient: state.get('chatHeightCoefficient'),
        inputBlocked: state.get('inputBlocked'),
        isLoadingData: state.get('isLoadingData'),
        chatMsgText: state.get('chatMsgText'),
        goBotOnMsg: state.get('goBotOnMsg'),
        goBotOnTyping: state.get('goBotOnTyping'),
        errors: state.get('errors'),
        locale: state.get('locale'),
        showTyping: isOppositeUserTyping(state),
        currentChatRoom,
        isDialogInputEmpty,
        companyBannedSKK,
        isCompanyC2C,
        disabledChat: !isPortalChatVisible,
    };
};

export const Dialog = connect(mapStateToProps)(toJS(DialogView));
